import { SendMoneySteps } from "./../../models/sendmoney/sendmoney";
import { UserProfileTMNIovation } from "./../../models/user/user.tm.profile.model";
import { usercommonattribute } from "./../../_services/userservice/user.common.service";
import { currentcartdetail } from "./../../models/dashboard/cart/mywallet.currentcart.Modal";
import { mywalletcard } from "./../../_services/mywallet/card/mywallet.card.service";
import { AddcardComponent } from "./../../mywallet/card/addcard/addcard.component";
import { AppSettings } from "./../../sharedcomponents/_common/constants/app.constants";
import { Component, OnInit, Output, ViewContainerRef } from "@angular/core";
import { Router } from "@angular/router";
import { overlayConfigFactory } from "angular2-modal";
import { BSModalContext, Modal } from "angular2-modal/plugins/bootstrap";
import { TranslateService } from "ng2-translate/ng2-translate";
import { Subject } from "rxjs/Subject";
import {
  AdditionalInfo,
  CardDetails,
  SendMoneyDetail,
  StoreDetails,
  SummaryDetails
} from "../../models/sendmoney/sendmoney";
import { AlertService } from "../../sharedcomponents/commonservice/alert.service";
import { CountryService } from "../../sharedcomponents/commonservice/countrylist.service";
import { utilityService } from "../../sharedcomponents/commonservice/utility.service";
import {
  enumStatusCodeList,
  PaymentType
} from "../../sharedcomponents/_common/constants/app.constants";
import { ErrorPopupComponent } from "../../sharedcomponents/_directive/error-popup/error-popup.component";
import { SendMoneyService } from "../../_services/sendmoneyservice/sendmoneyservice";
import { AuthService } from "../../_services/userservice/auth.service";
import { UserGioLocation } from "app/models/user/usergioLocation";
import { geolocation } from "app/sharedcomponents/commonservice/geolocation/geoloc";

@Component({
  selector: "app-payment-type",
  templateUrl: "./payment-type.component.html",
  styleUrls: ["./payment-type.component.css"],
  providers: [
    AuthService,
    AlertService,
    Modal,
    CountryService,
    mywalletcard
  ]
})
export class PaymentTypeComponent implements OnInit {
  PageFlow: any = {};
  sendMoneyDetail: SendMoneyDetail;
  paymentTypeData: any = {};
  paymentType: any;
  isStoreButtonVisible: boolean = true;
  isDebitButtonVisible: boolean = true;
  private subUserDetails = new Subject<boolean>();
  @Output()
  observableUserDetails = this.subUserDetails.asObservable();
  private subProfile = new Subject<boolean>();
  @Output()
  subProfileObservable = this.subProfile.asObservable();
  isCardHeaderVisible = false;
  activePath: string = "";
  dispalycardlist: any = [];
  currentcart: currentcartdetail;
  cardFundingID = 0;
  fundingID = "0";
  unsubDocReq: any;
  DocumentRequired: {};
  cardNotfound = "";
  isCardAddVisble = true;
  private subDocReq = new Subject<boolean>();
  isFirstLoad: boolean = true;
  @Output()
  observableDocReq = this.subDocReq.asObservable();
  cardMessage = "";
  userProfileTMNIovation: UserProfileTMNIovation;
  enableBackButton;
  mobileScreen = false;
  constructor(
    private router: Router,
    public modal: Modal,
    private sendMoneyService: SendMoneyService,
    public utilityServ: utilityService,
    public translate: TranslateService,
    public geoloc: geolocation,
    private cardservice: mywalletcard,
    private vcRef: ViewContainerRef,
    public usermodel: usercommonattribute
  ) {
    this.paymentType = PaymentType;
    this.PageFlow.Value = sessionStorage.PageFlow;
    this.sendMoneyDetail = new SendMoneyDetail();
    this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
      this.sendMoneyDetail = data;
    });
    if (this.PageFlow.Value == "repeatorder") {
      this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
        this.sendMoneyDetail = data;
      });
    } else {
      this.sendMoneyDetail.summaryDetails = new SummaryDetails();
      this.sendMoneyDetail.storeDetails = new StoreDetails();
      this.sendMoneyDetail.cardDetails = new CardDetails();
      this.sendMoneyDetail.additionalInfo = new AdditionalInfo();
      this.sendMoneyDetail.paymentDetails.paymentType = PaymentType.None;
    }
  }

  ngOnInit() {
    // commented not required any more
    // const IsPayatstore = true;
    // if (this.sendMoneyDetail.currentCartDetail.CustmerPaymentMethod == 0) {
    //   this.isStoreButtonVisible = false;
    //   this.isDebitButtonVisible = true;
    //   let userGioLocation = new UserGioLocation();
    //   this.utilityServ.busy = this.geoloc.getGioLocation().subscribe(data => {
    //     userGioLocation = data;
    //     this.geoloc.setserGioLocation(data);
    //     this.utilityServ.busy = this.sendMoneyService
    //       .loadStoresInMap(IsPayatstore, userGioLocation)
    //       .subscribe(
    //         data => {
    //           const resJSON = data;
    //           if (
    //             resJSON.Envelope.Body.StoresResponse.StatusCode ==
    //             enumStatusCodeList.SUCCESS
    //           ) {
    //             let tempStoreCollection: any = this.utilityServ.getArray(
    //               resJSON.Envelope.Body.StoresResponse.Stores.StoreDetail
    //             );
    //             if (tempStoreCollection.length > 0) {
    //               this.isStoreButtonVisible = true;
    //               this.isDebitButtonVisible = true;
    //             } else {
    //               this.isStoreButtonVisible = false;
    //               this.isDebitButtonVisible = true;
    //             }
    //           } else {
    //             this.isStoreButtonVisible = false;
    //             this.isDebitButtonVisible = true;
    //           }
    //         },
    //         error => {
    //           this.isStoreButtonVisible = false;
    //           this.isDebitButtonVisible = true;
    //           console.log("Observer got a next value: " + error);
    //         }
    //       );
    //   });
    // }

    if (this.sendMoneyDetail.currentCartDetail.CustmerPaymentMethod == 10) {
      this.isCardAddVisble = false;
    }

    this.activePath = this.router.url.split("/")[1];
    if (
      window.screen.width < Number(AppSettings.MOBILE_SCREEN_WIDTH) &&
      this.activePath == "mywalletcardlist"
    ) {
      this.mobileScreen = true;
    } else {
      this.mobileScreen = false;
    }

    if (
      this.activePath == "debitcard" ||
      this.activePath == "sendmoney" ||
      this.activePath == "repeatorder"
    ) {
      // Card Header
      this.sendMoneyService.getPageFlow().subscribe(data => {
        this.PageFlow = data;
      });
      this.currentcart = new currentcartdetail();
      this.sendMoneyDetail = new SendMoneyDetail();
      this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
        this.sendMoneyDetail = data;
      });
      this.sendMoneyService.getcurrentcartDetailData().subscribe(data => {
        this.currentcart = data;
        this.fundingID = this.currentcart.FundingId;
      });

      if (
        this.sendMoneyDetail.pickupTypeDetails.countryName == undefined ||
        this.sendMoneyDetail.pickupTypeDetails.countryName == ""
      ) {
        this.router.navigate(["/dashboard"]);
        return;
      }
    }
    if (this.usermodel.IsBeingLinked == "true") {
      this.getcardlist();
    }

    if (this.usermodel.IsBeingLinked == "false") {
      const modalData: any = {};
      modalData.Title = this.translate.instant("Common_lblOops");
      modalData.Message = this.translate.instant("IncompleteProfilePopup_desc");
      this.isCardAddVisble = false;
      this.cardNotfound = "";
    } else {
      this.cardNotfound = this.translate.instant(
        "DebitCard_lblAddCardInstruction"
      );
    }
  }
  OpenAddCard() {
    this.modal.overlay.defaultViewContainer = this.vcRef;
    const modalData: any = {};
    const _self = this;
    return this.modal
      .open(
        AddcardComponent,
        overlayConfigFactory({ modalData }, BSModalContext)
      )
      .then(function(obj) {
        obj.onDestroy.subscribe(data => {
         // if (modalData.next === "yes") {
            _self.getcardlist();
         // }
        });
      });
  }
  getcardlist() {
    this.dispalycardlist = new Array<CardDetails>();
    this.modal.overlay.defaultViewContainer = this.vcRef;
    this.utilityServ.busy = this.cardservice
      .getcardlistservice(this.fundingID)
      .subscribe(data => {
        this.isFirstLoad = false;
        if (data.Envelope.Body.GetFundingResponse.StatusCode == 20001) {
          return false;
        }
        if (
          data.Envelope.Body.GetFundingResponse.StatusCode ==
          enumStatusCodeList.SUCCESS
        ) {
          if (
            data.Envelope.Body.GetFundingResponse.Fundings.Funding != undefined
          ) {
            const cardList = this.utilityServ.getArray(
              data.Envelope.Body.GetFundingResponse.Fundings.Funding
            );
            console.log(cardList.length);
            cardList.forEach(element => {
              const crdDetail: CardDetails = new CardDetails();
              crdDetail.cardFundingID = this.utilityServ.getObjectText(
                element.FundingId
              );
              crdDetail.cardNickname = this.utilityServ.getObjectText(
                element.FriendlyName
              );
              crdDetail.cardlastfournum = this.utilityServ.getObjectText(
                element.AccountNumber
              );
              crdDetail.cardNumber = this.utilityServ.getObjectText(
                element.AccountNumber
              );
              this.utilityServ.getObjectText(element.CardTypeImage);
              // crdDetail.cardimageurl = AppSettings.imagefolder + ICE_DebitCard[this.utilityServ.getObjectText(element.SubType)] + '.png';
              crdDetail.cardimageurl =
                AppSettings.baseContentURL +
                this.utilityServ.getObjectText(element.CardTypeImage);

              this.dispalycardlist.push(crdDetail);
            });
            if (this.fundingID != "") {
              this.isCardAddVisble = false;
            }
          }
        } else {
          this.translate.use(sessionStorage.langCode).subscribe(res => {
            let modalData: any = {};
            modalData.Title = this.translate.instant("Common_lblOops");
            modalData.Message =
              data.Envelope.Body.GetFundingResponse.StatusMessage;
            this.modal.open(
              ErrorPopupComponent,
              overlayConfigFactory({ modalData }, BSModalContext)
            );
          });
        }
      });
  }

  payClick(obj) {
    const cardDetails: CardDetails = new CardDetails();
    cardDetails.cardNickname = obj.cardNickname;
    cardDetails.cardimageurl = obj.cardimageurl;
    cardDetails.cardNumber = obj.cardlastfournum;
    cardDetails.cardlastfournum = obj.cardlastfournum;
    this.sendMoneyDetail.paymentDetails.fundingId = obj.cardFundingID;
    this.sendMoneyDetail.cardDetails = cardDetails;

    this.sendMoneyDetail.paymentDetails.paymentType = PaymentType.DebitCard;

    const storeDetails: StoreDetails = new StoreDetails();
    this.sendMoneyDetail.storeDetails = storeDetails;

    this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
    if (this.PageFlow.Value == "repeatorder") {
      this.router.navigate(["/repeatorderlist"]);
      return;
    } else {
      this.sendMoneyService.setModalPopup(SendMoneySteps.Summary);
      this.router.navigate(["/sendmoney"]);
      return;
    }
  }

  continueClick() {
    this.router.navigate(["/dashboard"]);
  }

  paymentTypeClick(paymentType) {
    if (paymentType === PaymentType.PayAtStore) {
      this.sendMoneyDetail.paymentDetails.paymentType = PaymentType.PayAtStore;
      this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
      this.router.navigate(["/payatstore"]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sendMoney/payment-type/payment-type.component.ts